// extracted by mini-css-extract-plugin
export default {"invertTextColor":"invert-text-color_invertTextColor"};